export const ACTIONS = {
  CHANNELS_GET_ALL_REQUEST: "channels-get-all-request",
  CHANNELS_GET_ALL_SUCCESS: "channels-get-all-success",
  CHANNELS_GET_ALL_FAILURE: "channels-get-all-failure",
  CHANNELS_GET_ONE_REQUEST: "channels-get-one-request",
  CHANNELS_GET_ONE_SUCCESS: "channels-get-one-success",
  CHANNELS_GET_ONE_FAILURE: "channels-get-one-failure",
  CHANNELS_EDIT_ONE_REQUEST: "channels-edit-one-request",
  CHANNELS_EDIT_ONE_SUCCESS: "channels-edit-one-success",
  CHANNELS_EDIT_ONE_FAILURE: "channels-edit-one-failure",
  CHANNELS_DELETE_ONE_REQUEST: "channels-delete-one-request",
  CHANNELS_DELETE_ONE_SUCCESS: "channels-delete-one-success",
  CHANNELS_DELETE_ONE_FAILURE: "channels-delete-one-failure",
  CHANNELS_CREATE_ONE_REQUEST: "channels-create-one-request",
  CHANNELS_CREATE_ONE_SUCCESS: "channels-create-one-success",
  CHANNELS_CREATE_ONE_FAILURE: "channels-create-one-failure",
  STUDIO_TOKEN_REQUEST: "studio-token-request",
  STUDIO_TOKEN_SUCCESS: "studio-token-success",
  STUDIO_TOKEN_FAILURE: "studio-token-failure",
  BROADCAST_SETTINGS_REQUEST: "broadcast-settings-request",
  BROADCAST_SETTINGS_SUCCESS: "broadcast-settings-success",
  BROADCAST_SETTINGS_FAILURE: "broadcast-settings-failure",
  EDITOR_CONFIG_CHANNEL_SHOW: "editor-config-channel-show",
  EDITOR_CONFIG_CHANNEL_HIDE: "editor-config-channel-hide",
  EDITOR_DELETE_WARNING_MODAL_SHOW: "editor-delete-warning-modal-show",
  EDITOR_DELETE_WARNING_MODAL_HIDE: "editor-delete-warning-modal-hide",
  EDITOR_RENAME_MODAL_SHOW: "editor-rename-modal-show",
  EDITOR_RENAME_MODAL_HIDE: "editor-rename-modal-hide",
  EDITOR_CREATE_MODAL_SHOW: "editor-create-modal-show",
  EDITOR_CREATE_MODAL_HIDE: "editor-create-modal-hide",
  EDITOR_LOADING_STATE: "editor-loading-state",
  EDITOR_CONFIG_CHANNEL_PRESENT: "editor-config-channel-present",
  EDITOR_SELECT_CHANNEL: "editor-select-channel",
  EDITOR_DESELECT_CHANNEL: "editor-deselect-channel",
  EDITOR_THIRD_PARTY_AUTH_ADD: "editor-third-party-auth-add",
  EDITOR_THIRD_PARTY_AUTH_REMOVE: "editor-third-party-auth-remove",
  EDITOR_PASSWORD_AUTH_ADD: "editor-password-auth-add",
  EDITOR_PASSWORD_AUTH_REMOVE: "editor-password-auth-remove",
  EDITOR_AUTH_REQUEST: "editor-auth-request",
  EDITOR_AUTH_SUCCESS: "editor-auth-success",
  EDITOR_AUTH_FAILURE: "editor-auth-failure",
  EDITOR_AUTH_REMOVE_REQUEST: "editor-auth-remove-request",
  EDITOR_AUTH_REMOVE_SUCCESS: "editor-auth-remove-success",
  EDITOR_AUTH_REMOVE_FAILURE: "editor-auth-remove-failure",
  EDITOR_PASSWORD_AUTH_REQUEST: "editor-password-auth-request",
  EDITOR_PASSWORD_AUTH_SUCCESS: "editor-password-auth-success",
  EDITOR_PASSWORD_AUTH_FAILURE: "editor-password-auth-failure",
  EDITOR_PASSWORD_AUTH_REMOVE_REQUEST: "editor-password-auth-remove-request",
  EDITOR_PASSWORD_AUTH_REMOVE_SUCCESS: "editor-password-auth-remove-success",
  EDITOR_PASSWORD_AUTH_REMOVE_FAILURE: "editor-password-auth-remove-failure",
  EDITOR_PUBLIC_PRIVATE_AUTH_REQUEST: "editor-public-private-auth-request",
  EDITOR_PUBLIC_PRIVATE_AUTH_SUCCESS: "editor-public-private-auth-success",
  EDITOR_PUBLIC_PRIVATE_AUTH_FAILURE: "editor-public-private-auth-failure",
  EDITOR_REMOVE_ERROR: "editor-remove-error",
  EDITOR_REMOVE_ERROR_CONFIRM: "editor-remove-error-confirm",
  VIEWER_GET_CHANNEL_REQUEST: "viewer-get-channel-request",
  VIEWER_GET_CHANNEL_SUCCESS: "viewer-get-channel-success",
  VIEWER_GET_CHANNEL_FAILURE: "viewer-get-channel-failure",
  VIEWER_GET_BROADCAST_SETTINGS_REQUEST:
    "viewer-get-broadcast-settings-request",
  VIEWER_GET_BROADCAST_SETTINGS_SUCCESS:
    "viewer-get-broadcast-settings-success",
  VIEWER_GET_BROADCAST_SETTINGS_FAILURE:
    "viewer-get-broadcast-settings-failure",
  VIEWER_GET_PLAYBACK_URL_REQUEST: "viewer-get-playback-url-request",
  VIEWER_GET_PLAYBACK_URL_SUCCESS: "viewer-get-playback-url-success",
  VIEWER_GET_PLAYBACK_URL_FAILURE: "viewer-get-playback-url-failure",
  VIEWER_STREAM_STATE_POLLING_START: "viewer-stream-state-polling-start",
  VIEWER_STREAM_STATE_POLLING_END: "viewer-stream-state-polling-end",
  VIEWER_STREAM_STATE_SET: "viewer-stream-state-set",
  VIEWER_STREAM_STATE_SUCCESS: "viewer-stream-state-polling-success",
  VIEWER_STREAM_STATE_FAILURE: "viewer-stream-state-polling-failure",
  VIEWER_COUNT_POLLING_START: "viewer-count-polling-start",
  VIEWER_COUNT_POLLING_END: "viewer-count-polling-end",
  VIEWER_COUNT_SUCCESS: "viewer-count-polling-success",
  VIEWER_COUNT_FAILURE: "viewer-count-polling-failure",
  VIEWER_REACT_TO_STREAM_REQUEST: "viewer-react-to-stream-request",
  VIEWER_REACT_TO_STREAM_SUCCESS: "viewer-react-to-stream-success",
  VIEWER_REACT_TO_STREAM_FAILURE: "viewer-react-to-stream-failure",
  VIEWER_REACT_TO_STREAM_REACTION: "viewer-react-to-stream-reaction",
  VIEWER_REMOVE_STREAM_REACTION: "viewer-remove-stream-reaction",
  VIEWER_VERIFY_PASSWORD_REQUEST: "viewer-verify-password-request",
  VIEWER_VERIFY_PASSWORD_SUCCESS: "viewer-verify-password-success",
  VIEWER_VERIFY_PASSWORD_FAILURE: "viewer-verify-password-failure",
  VIEWER_REFRESH_TOKEN_POLLING_START: "viewer-refresh-token-polling-start",
  VIEWER_REFRESH_TOKEN_POLLING_END: "viewer-refresh-token-polling-end",
  VIEWER_REFRESH_TOKEN_POLLING_SUCCESS: "viewer-refresh-token-polling-success",
  VIEWER_REFRESH_TOKEN_POLLING_FAILURE: "viewer-refresh-token-polling-failure",
  VIEWER_AUTH_REQUEST: "viewer-auth-request",
  VIEWER_AUTH_SUCCESS: "viewer-auth-success",
  VIEWER_AUTH_FAILURE: "viewer-auth-failure",
  VIEWER_AUTH_REMOVE: "viewer-auth-remove",
};
